export const Cookie = {
  set: function(name, value, days = null) {
    var domain, domainParts, date, expires, host;

    if (days) {
      date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }

    host = window.location.host;
    if (host.split(".").length === 1) {
      document.cookie = name + "=" + value + expires + "; path=/";
    } else {
      domainParts = host.split(".");
      if (domainParts.length > 2) {
        domainParts.shift();
      }
      domain = "." + domainParts.join(".");

      document.cookie =
        name + "=" + value + expires + "; path=/; domain=" + domain;

      if (
        (Cookie.get(name) === null || Cookie.get(name) !== value) &&
        !Cookie.isCommonTimeStampCookie(name)
      ) {
        domain = "." + host;
        document.cookie =
          name + "=" + value + expires + "; path=/; domain=" + domain;
      }
    }
  },

  get: function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  isCommonTimeStampCookie: function(cookieName) {
    var timeStampCookieNames =
      "refreshToeknFailedTimestamp,tokenIssueTimestamp,lastActivityTimestamp";
    if (cookieName) {
      if (timeStampCookieNames.indexOf(cookieName) !== -1) {
        return true;
      }
    }
    return false;
  },
  erase: function(name) {
    Cookie.set(name, "", -1);
  },
};
